import { Component, inject, OnInit } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { LayoutService } from 'app/layout/layout.service';
import { RealTimeService } from 'app/real-time.service';
import { take } from 'rxjs';

@Component({
  selector: 'aep-notifications',
  imports: [
    MatBadge,
    MatIcon,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  standalone: true,
})
export class NotificationsComponent implements OnInit {
  
  notificationCount: any = 0;
  badgeHidden: boolean = true;
  
  private _fuseSidebarService = inject(FuseSidebarService);
  private layoutService =  inject(LayoutService);
  private _realTimeService = inject(RealTimeService);
  
  ngOnInit(): void {
    this.layoutService.fetchUndeliveredAndUnreadNotificationCount().subscribe((response) => {
      this.notificationCount = (response.count <= 99) ? response.count : '+99';
      if (this.notificationCount > 0) {
        this.badgeHidden = false;
      }
    });

    this._realTimeService
          .getRealTimeNotification()
          .subscribe((notification) => {
            this.notificationCount += 1;
            this.notificationCount = (this.notificationCount <= 99) ? this.notificationCount : '+99';

            if (this.notificationCount > 0) this.badgeHidden = false;
          });
  }

  openNotifications(): void{
    const key = 'quickPanel';
    if (!this._fuseSidebarService.getSidebar(key).opened) {
      this.layoutService.MarkQuestionsAsReaded().subscribe(() => {});
    }
    this._fuseSidebarService.getSidebar(key).toggleOpen();
    
    // susbscribe to toggleOpene quickPanel for close if from the intern of the panel 
    this.layoutService.quickPanelToggleOpen.pipe(take(1)).subscribe((res) => {
      if (res[0]) {
        this._fuseSidebarService.getSidebar(key).close();
      }
    });

    if (this.badgeHidden === false) {
      setTimeout(() => this.notificationCount = 0, 500);
      this.layoutService
        .notificationDelivered()
        .subscribe(() => {
          this.badgeHidden = true;

        });
    }
  }

  
}
